const Image = async(file)=>{
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "zupptravel");
    const response = await fetch(`https://api.cloudinary.com/v1_1/dhbed8btg/auto/upload`, {
        method: "POST",
        body: formData
    });
    const data = await response.json();
    return data["secure_url"];
}

/** Upload image or PDF; PDFs are converted to first-page PNG URL for AI vision */
export const uploadTicketDocument = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "zupptravel");
    const response = await fetch(`https://api.cloudinary.com/v1_1/dhbed8btg/auto/upload`, {
        method: "POST",
        body: formData
    });
    const data = await response.json();
    if (data.error) {
        throw new Error(data.error.message || "Upload failed");
    }
    const url = data.secure_url;
    const isPdf =
        file.type === "application/pdf" ||
        (file.name && file.name.toLowerCase().endsWith(".pdf")) ||
        url.toLowerCase().includes(".pdf");
    if (isPdf) {
        // Cloudinary: deliver first PDF page as PNG for vision AI
        return url.replace("/upload/", "/upload/pg_1,f_png/");
    }
    return url;
};

export default Image;